import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';
import UserAvatar from '../UserAvatar';

import * as S from './styled';

const TrackedProgress = ({
  isMobile,
  onUserClick,
  size,
  stats,
  usersStats,
  showAvatarsIfEmpty,
  selectedUserIds,
}) => (
  <S.TrackedProgress isMobile={isMobile}>
    {(showAvatarsIfEmpty || (!showAvatarsIfEmpty && !!usersStats.length)) && (
      <S.AvatarsGroup>
        {usersStats.map((stat) => (
          <S.UserAvatar
            key={stat.id}
            onClick={() => {
              onUserClick(stat.user?.id);
            }}
          >
            <Tooltip
              title={
                <S.Tooltip>
                  <S.Column>
                    <S.TooltipText>{stat.user?.fullName}:</S.TooltipText>
                  </S.Column>
                  <S.MarginLeft />
                  <S.Column>
                    <S.TooltipText>{stat.loggedString} logged</S.TooltipText>
                  </S.Column>
                </S.Tooltip>
              }
            >
              <UserAvatar
                src={
                  stat.user?.avatarUrl ? `${stat.user.avatarUrl}/50.png` : null
                }
                initials={stat.user?.initials ?? 'UN'}
                isSelected={selectedUserIds.includes(stat.user?.id) || (stat.isSelected ?? false)}
                size="tiny"
              />
            </Tooltip>
          </S.UserAvatar>
        ))}
      </S.AvatarsGroup>
    )}
    <S.ProgressBar size={size}>
      <div
        style={{
          width: `${stats.leftPercentage}%`,
          // backgroundColor: 'rgb(0, 82, 204)',
          backgroundColor: 'rgb(66, 82, 110)',
          flexShrink: '0',
          transition: 'width 0.3s ease 0s',
        }}
      />
      <div
        style={{
          width: `${stats.rightPercentage}%`,
          backgroundColor: stats.isOverEstimate
            ? 'rgb(255, 171, 0)'
            : 'rgb(223, 225, 230)',
          flexShrink: '0',
          transition: 'width 0.3s ease 0s',
        }}
      />
    </S.ProgressBar>
    <S.TotalTrackedTime>
      <span>{stats.leftMark}</span>
      <span>{stats.rightMark}</span>
    </S.TotalTrackedTime>
  </S.TrackedProgress>
);

TrackedProgress.propTypes = {
  isMobile: PropTypes.bool,
  onUserClick: PropTypes.func,
  size: PropTypes.string,
  usersStats: PropTypes.array,
  showAvatarsIfEmpty: PropTypes.bool,
  stats: PropTypes.shape({
    leftPercentage: PropTypes.number.isRequired,
    rightPercentage: PropTypes.number.isRequired,

    leftMark: PropTypes.string.isRequired,
    rightMark: PropTypes.string.isRequired,

    isOverEstimate: PropTypes.bool.isRequired,
  }).isRequired,
  selectedUserIds: PropTypes.array,
};

TrackedProgress.defaultProps = {
  usersStats: [],
  isMobile: false,
  size: 'small',
  showAvatarsIfEmpty: true,
  selectedUserIds: [],
};

export default TrackedProgress;
